<template>
  <div class="submission-preview d-flex align-items-start">
    <b-img
      v-if="submission.present.image_url"
      :src="submission.present.image_url"
      width="72"
      height="72"
      class="mr-1 rounded submission-preview-image"
    />
    <div class="flex-grow-1">
      <div class="font-weight-bold">
        {{ submission.present.title }}
      </div>
      <small class="text-muted">{{ submission.type_label }} · {{ submission.action_label }}</small>
      <audio
        v-if="submission.present.audio_url"
        :src="submission.present.audio_url"
        controls
        preload="none"
        class="d-block mt-50"
        style="max-width: 280px;"
      />
      <table
        v-if="diffRows.length"
        class="table table-sm table-borderless mt-50 mb-0 submission-preview-diff"
      >
        <tr
          v-for="row in diffRows"
          :key="row.field"
        >
          <td class="text-muted pl-0">
            {{ row.field }}
          </td>
          <td class="text-danger"><s>{{ row.before }}</s></td>
          <td class="text-success">
            {{ row.after }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { BImg } from 'bootstrap-vue'

const FIELD_LABELS = {
  name: 'Название',
  difficulty: 'Сложность',
  current_members: 'Текущий состав',
  former_members: 'Бывшие участники',
  title: 'Название',
  play_count: 'Прослушивания',
  difficulty_rating: 'Рейтинг сложности',
  release_year: 'Год',
  ignore: 'Игнор',
  similars: 'Похожие',
  rejected: 'Не похожи',
}

export default {
  components: { BImg },
  props: {
    submission: { type: Object, required: true },
  },
  computed: {
    diffRows() {
      const after = this.submission.present.after || {}
      const before = this.submission.present.before || {}
      return Object.keys(after).map(field => ({
        field: FIELD_LABELS[field] || field,
        before: before[field] === undefined || before[field] === null || before[field] === '' ? '—' : before[field],
        after: after[field] === null || after[field] === '' ? '—' : after[field],
      }))
    },
  },
}
</script>

<style scoped>
.submission-preview-image {
  object-fit: cover;
}
.submission-preview-diff td {
  white-space: pre-line;
  padding: 0 0.5rem 0 0;
}
</style>
